export const store = {
  openSidebar: () => {},
  /** @type {"" | "general" | "booth8" | "booth12" | "cocktailBooth"} */
  preferredTicketShop: "",
};
